import React from 'react'
import openLink from '../../icons/open.svg'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { useI18nFunction } from '../I18n'

const GoToCase = ({ caseId }) => {
  const I18nFunction = useI18nFunction()

  return (
    <CaseLinkWrapper title={I18nFunction({ id: "Go_to_case" })} button Case>
      <CaseLink to={`/cases/${caseId}`} onClick={(e) => e.stopPropagation()}>
        <OpenLink src={openLink} />
      </CaseLink>
    </CaseLinkWrapper>
  )
}

const OpenLink = styled.img`
height: 2em;
`
export const CaseLink = styled(Link)`
  padding: 0.7em;
  text-decoration: none;
  }
`
const CaseLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  z-index:1;
  cursor: ${({ button }) => button ? 'pointer' : 'inherit'};
    &:hover {
    background-color: ${({ theme, button }) => button ? theme.listItemHover : 'inherit'};
 
`
export default GoToCase